import angular from 'angular';
import ResourcesModule from '../../resources/resources';
import template from './exploreBreakdownModalContentWrapperNg1.jade';
import {thickColumnDecorateSerie} from '../../common/util/chart-util';

class ExploreBreakdownModalContentWrapperController {
  constructor(Resource, $q, $stateParams, $timeout, $filter, currentExploreGroupForCharts, ggCSV, ggTable, UserExplorerResource) {
    this.Resource = Resource;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.UserExplorerResource = UserExplorerResource;
    this.currentExploreGroupForCharts = currentExploreGroupForCharts;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.ggCSV = ggCSV;
    this.ggTable = ggTable;
    this.deferredAge = $q.defer();
    this.deferredCountry = $q.defer();
    this.deferredApps = $q.defer();
    this.deferredGenres = $q.defer();
    this.deferredIncome = $q.defer();
    this.metricsWithSeriesChart = ['age', 'genre', 'income', 'apps'];
    this.$q = $q;
    this.deferredTableData = this.$q.defer();

    this.buildSeriesTable();

    this.tableMetrics = {
      age: [
        {
          metric: 'age_range',
          format: 'string'
        }
      ],
      country: [
        {
          metric: 'country_name',
          format: 'string'
        }
      ],
      apps: [
        {
          metric: 'apps',
          format: 'string'
        },
        {
          metric: 'gameDeveloper',
          format: 'string'
        },
        {
          metric: 'app_store',
          format: 'string'
        },
        {
          metric: 'rating',
          format: 'number'
        }
      ],
      genre: [
        {
          metric: 'genre',
          format: 'string'
        }
      ],
      income: [
        {
          metric: 'income',
          format: 'string'
        }
      ]
    };

    this.mapCallbacks = { dataRetrievedCallback: ((res) => this.recreateTable(_.assign(res, {seriesName: 'location'})))};

    this.series = {
      age: [{
        label:'User Group',
        type: 'column',
        format: 'number',
        metric: 'age',
        getData: ((filters) => { this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'AGE'})}),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'age')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true)),
        dataRetrievedCallback: ((res, serie) => this.recreateTable(_.assign(res, {seriesName: serie})))
      },{
        label:'Game Benchmark',
        type: 'column',
        format: 'number',
        metric: 'age',
        getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'AGE'})),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'age')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true))
      }],
      apps: [{
        label:'User Group',
        type: 'column',
        format: 'number',
        noDateInTooltip: true,
        getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'APPS'})),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'apps')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true)),
        dataRetrievedCallback: ((res, serie) => this.recreateTable(_.assign(res, {seriesName: serie})))
      },{
        label:'Game Benchmark',
        type: 'column',
        format: 'number',
        noDateInTooltip: true,
        getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'APPS'})),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'apps')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true))
      }],
      genre: [{
        label:'User Group',
        type: 'column',
        format: 'number',
        getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'GENRE'})),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'genre')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true)),
        dataRetrievedCallback: ((res, serie) => this.recreateTable(_.assign(res, {seriesName: serie})))
      },{
        label:'Game Benchmark',
        type: 'column',
        format: 'number',
        getData: ((filters) => this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(filters, 'breakdown', {breakdown_dimension: 'GENRE'})),
        transformResponse: ((res) => this.transformSeriesBreakdownResponse(res, 'genre')),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true))
      }],
      income: [{
        type: 'column',
        format: 'number',
        getData: ((filters) => this.deferredIncome.promise),
        decorateSerie: ((serie) => thickColumnDecorateSerie(serie, 35, true)),
        dataRetrievedCallback: ((res, serie) => this.recreateTable(_.assign(res, {seriesName: serie})))
      }]
    };
  }

  recreateTable(res) {
    this.buildSeriesTable();
    this.deferredTableData.resolve(res);
  }

  transformSeriesBreakdownResponse(res, metric) {
    let userGroupSeries = { data:{ rows:[], summary:{} } };
    let benchmarkSeries = { data:{ rows:[], summary:{} } };

    if(metric == 'apps') {
      let sortedAppsBreakdown = _.sortBy(res[0].breakdown, 'usergroup_value');
      let firstTenApps = sortedAppsBreakdown.slice(-50).reverse();
      res[0].breakdown = firstTenApps;
      _.forOwn(res[0].breakdown, (breakdownObject, key) => {
        userGroupSeries.data.rows.push({key: breakdownObject.app_name, tooltipTitle: breakdownObject.app_name, value: breakdownObject.usergroup_value});
        benchmarkSeries.data.rows.push({key: breakdownObject.app_name, tooltipTitle: breakdownObject.app_name, value: breakdownObject.benchmark_value});
      });
    } else {
      _.forOwn(res[0].breakdown, (breakdownObject, key) => {
        userGroupSeries.data.rows.push({key: breakdownObject.dimension_value, value: breakdownObject.usergroup_value});
        benchmarkSeries.data.rows.push({key: breakdownObject.dimension_value, value: breakdownObject.benchmark_value});
      });
    }

    userGroupSeries.data.summary.avg = res[0].total_usergroup / userGroupSeries.data.rows.length;
    benchmarkSeries.data.summary.avg = res[0].total_benchmark / userGroupSeries.data.rows.length;

    return [userGroupSeries, benchmarkSeries];
  }

  updateTableData(res, seriesName, ggTableParams) {
    if(seriesName == 'location') { ggTableParams.total(res.breakdown.length); }
    else { ggTableParams.total(res[0].breakdown.length); }
    return this.refreshTable(res, seriesName).slice((ggTableParams.page() - 1) * ggTableParams.count(), ggTableParams.page() * ggTableParams.count());
  }

  refreshTable(res, serieName) {
    let tableCols = this.tableMetrics[this.metric].map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        filter: {[exploreMetric.metric]: 'text'},
        sortable: exploreMetric.metric,
        title: this.translate(exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }).concat(
      this.getCommonColumns(serieName)
    );

    this.seriesTable.cols = tableCols;

    return this.createTableData(res, serieName);
  };

  createTableData(res, serieName) {
    let tableRows = [];
    if(serieName == "age") {
      _.forOwn(res[0].breakdown, (breakdownObject, key) => {
        tableRows.push({
          age_range: breakdownObject.dimension_value,
          user_group_size: breakdownObject.usergroup_value,
          benchmark_size: breakdownObject.benchmark_value
        });
      });
    } else if(serieName == "apps") {
      _.forOwn(res[0].breakdown, (breakdownObject, key) => {
        tableRows.push({
          apps: { appName: breakdownObject.app_name, icon_url: breakdownObject.icon },
          gameDeveloper: breakdownObject.developer,
          app_store: breakdownObject.app_store,
          rating: breakdownObject.rating,
          user_group_size: breakdownObject.usergroup_value,
          benchmark_size: breakdownObject.benchmark_value
        });
      });
    } else if(serieName == "location") {
      _.forOwn(res.breakdown, (breakdownObject, key) => {
        tableRows.push({
          country_name: breakdownObject.dimension_value,
          user_group_size: breakdownObject.usergroup_value,
          benchmark_size: breakdownObject.benchmark_value
        });
      });
    } else if(serieName == "genre") {
      _.forOwn(res[0].breakdown, (breakdownObject, key) => {
        tableRows.push({
          genre: breakdownObject.dimension_value,
          user_group_size: breakdownObject.usergroup_value,
          benchmark_size: breakdownObject.benchmark_value
        });
      });
    }

    let usergroupsSizeSum = 0;
    let benchmarkSizeSum = 0;

    _.forEach(tableRows, (row) => {
      usergroupsSizeSum += row.user_group_size;
      benchmarkSizeSum += row.benchmark_size;
    });

    _.forEach(tableRows, (row) => {
      row.user_group_percentage = row.user_group_size / usergroupsSizeSum * 100;
      row.benchmark_percentage = row.benchmark_size / benchmarkSizeSum * 100;
      row.comparison = (row.user_group_percentage - row.benchmark_percentage) / row.benchmark_percentage  * 100;
    });

    return tableRows;
  }

  getCommonColumns(serieName) {
    let columns = [
      {
        field: 'user_group_size',
        metric: 'user_group_size',
        sortable: 'user_group_size',
        format: 'number',
        title: this.translateWith('size','user_group'),
        show: true
      },
      {
        field: 'user_group_percentage',
        metric: 'user_group_percentage',
        sortable: 'user_group_percentage',
        format: 'percentage',
        title: this.translate('user_group') + ' ' + this.translate('percentage'),
        show: true
      },
      {
        field: 'benchmark_size',
        metric: 'benchmark_size',
        sortable: 'benchmark_size',
        format: 'number',
        title: this.translateWith('size','benchmark'),
        show: true
      },
      {
        field: 'benchmark_percentage',
        metric: 'benchmark_percentage',
        sortable: 'benchmark_percentage',
        format: 'percentage',
        title: this.translate('benchmark') + ' ' + this.translate('percentage'),
        show: true
      },
      {
        field: 'comparison',
        metric: 'comparison',
        sortable: 'comparison',
        format: 'percentage',
        title: this.translate('comparison'),
        show: true
      }
    ];

    if(serieName == 'apps') {
      _.remove(columns, (column) => {
        return column.field == 'user_group_size' || column.field == 'benchmark_size';
      });
    }

    return columns;
  }

  showBreakdownSeriesChart() {
    return this.metricsWithSeriesChart.includes(this.metric);
  }

  buildSeriesTable() {
    // reinitializing promise to get new data
    this.deferredTableData = this.$q.defer();
    this.csv = new this.ggCSV();
    this.seriesTable = new this.ggTable({
      count: 30,
      counts: [10, 30, 50, 100, 250],
      getData: ((ggTableParams) => {
        return this.deferredTableData.promise.then((res) => {
          return this.updateTableData(res, res.seriesName, ggTableParams);
        });

      })
    });
  }

  getSeriesConfig() {
    return this.series[this.metric];
  }

  getMetric() {
    return this.metric;
  }

}

export let ExploreBreakdownModalContentWrapperComponent = {
  template: `
            <explore-trend-widget-header 
                class='w-bg u-pl0 u-mb0'
                titledynamic='vm.titledynamic'
                subtitledynamic='vm.subtitledynamic'
                icondynamic='vm.icondynamic'
            >
            </explore-trend-widget-header>
            <analytics-panels
              ng-if="vm.showBreakdownSeriesChart()"
              scope-name='explore',
              query='vm.currentExploreGroupForCharts'
              class='o-layout-chart__wrapper remove-highcharts-container-negative-margin'>
                <analytics-panel
                  class="w-bg o-layout-chart__item u-pl0 u-mb0",
                  tooltip-share='true',
                  force-single-y-axis='true',
                  is-x-axis-category="true",
                  series-name='{{vm.metric}}',
                  series='vm.getSeriesConfig()',
                  explore='true'
                  hide-chart-header='true'
                >
                </analytics-panel>
            </analytics-panels>
            <player-explore-map
              ng-if='vm.metric=="country"'
              callbacks='vm.mapCallbacks'
              query='vm.currentExploreGroupForCharts'
            ></player-explore-map>
            <div class="o-wrapper o-wrapper--fluid u-p0">
              <table ng-table-dynamic="vm.seriesTable with vm.seriesTable.cols" class="c-table u-bt">
                <tr class="c-table__filters">
                  <td ng-repeat="col in vm.seriesTable.cols" ng-show="col.show">
                    <input type="text" name="{{col.field}}" ng-model="vm.seriesTable.filter()[col.field]"/>
                  </td>
                </tr>
                <tr class="c-table__totals">
                  <td ng-repeat="total in vm.seriesTable.totals" ng-show="total.show"><b>{{ total.value | format:total.format }}</b></td>
                </tr>
                
                <tr ng-if="vm.metric != 'apps'" ng-repeat="row in $data">
                  <td ng-repeat="col in vm.seriesTable.cols" ng-show="col.show">{{ row[col.field] | format:col.format }}</td>
                </tr>
                
                <tr ng-if="vm.metric == 'apps'" ng-repeat="row in $data">
                  <td ng-repeat="col in vm.seriesTable.cols" ng-show="col.show">
                  
                    <div ng-if="col.field =='apps'" style="text-align: left;">
                      <img ng-if="col.field =='apps'" ng-src="{{row.apps.icon_url}}" class="u-mr- c-thumbnail--small c-thumbnail"/>
                      <label ng-if="col.field =='apps'">{{ row.apps.appName | format:col.format }}</label>
                    </div>
                    
                    <a ng-if="col.field =='app_store'" href="{{row.app_store}}" target="_blank">Appstore</a>
                    
                    <div ng-if="col.field =='rating'" style="margin-left: auto; margin-right: auto;" class="star-ratings-css">
                        <div ng-style="{'width': row.rating / 5 * 100 + '%'}" class="star-ratings-css-top">
                            <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                         </div>
                         <div class="star-ratings-css-bottom">
                            <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                         </div>
                     </div>
                    
                    <label ng-if="col.field !='apps' && col.field !='app_store' && col.field !='rating'" ng-show="col.show">
                        {{ row[col.field] | format:col.format }}
                    </label>
                    
                  </td>
                </tr>
                
              </table>
            </div>
            `,
  controller: ExploreBreakdownModalContentWrapperController,
  controllerAs: 'vm',
  bindings: {
    metric: '=',
    title: "@",
    titledynamic: "=",
    subtitle: "@",
    subtitledynamic: "=",
    icon: "@",
    icondynamic: "="
  }
};

export default angular.module('app.components.explore.breakdownModalContentWrapper', [
  ResourcesModule.name
])
  .component('exploreBreakdownModalContentWrapper',  ExploreBreakdownModalContentWrapperComponent);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreBreakdownModalContentWrapperNg1.js
 **/